import { IClientsContract } from 'src/utils/Interfaces/client.interface'
import { ContractList } from './ContractList'
import { NewContract } from './NewContract'
import style from './style.module.scss'

interface Props {
  items: IClientsContract[]
}

export const Contracts = ({ items }: Props) => {
  console.log(items)
  // Temporary dummy data
  const dummyItems = JSON.parse(localStorage.getItem('contracts') || '[]') as unknown as IClientsContract[]

  return (
    <div className={style.contract}>
      <div className={style.actions}>
        <NewContract />
      </div>
      <div className={style.content}>
        <ContractList items={dummyItems} />
      </div>
    </div>
  )
}
